<template>
  <div class="chat-container" :class="direction">
    <div class="chat-content" :class="direction">
      <div class="chat" :class="[direction, color]">
        <p class="chat-message">{{ text }}</p>
      </div>
      <p class="chat-name">{{ name }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    direction: String,
    text: String,
    color: String,
    name: String,
  },
};
</script>
<style lang="scss" scoped>
$blue-color: rgb(66, 124, 194);
$gray-color: rgb(70, 70, 70);

.chat-container {
  display: flex;

  max-width: 100%;
  margin: auto;
}
.chat-name {
  margin: 0;
  font-size: 0.8em;
  color: #575757;
  margin: 0 1rem;
  margin-top: -.4em
}
.chat-message {
  text-align: left;
  margin: 0;
}
.chat-content {
  display: flex;
  flex-direction: column;
}

.chat {
  font-family: "Roboto", sans-serif;
  color: white;
  margin: 10px;
  padding: 10px 15px;
  border-radius: 25px;
  position: relative;
  width: auto;
}

.right {
  justify-content: flex-end;
  text-align: right;
}
.left {
  justify-content: flex-start;
  text-align: left;
}

.blue {
  background-color: $blue-color;
}
.gray {
  background-color: $gray-color;
}

.blue:after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  width: 0;
  height: 0;
  border: 23px solid transparent;
  border-left-color: $blue-color;
  border-right: 0;
  border-bottom: 0;
  margin-top: -5px;
  margin-right: -9px;
}

.gray:after {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 0;
  height: 0;
  border: 23px solid transparent;
  border-right-color: $gray-color;
  border-left: 0;
  border-bottom: 0;
  margin-top: -5px;
  margin-left: -9px;
}

.chat-name {
  position: relative;
}
</style>
